import {Component, OnInit} from '@angular/core';
import {Document} from '../documents/document-countries/document-countries.component';

@Component({
  selector: 'app-rental-agreement',
  templateUrl: './rental-agreement.component.html',
})

export class RentalAgreementComponent implements OnInit {
  countries: Array<Document> = [
    {
      countryName: 'Россия',
      img: 'ru.svg',
      docHref: 'rental-agreement.html'
    },
    {
      countryName: 'Казахстан',
      img: 'kz.svg',
      docHref: 'rental-agreement-kz.html'
    },
    {
      countryName: 'Кыргызстан',
      img: 'kg.svg',
      docHref: 'rental-agreement-kg.html'
    },
    {
      countryName: 'Беларусь',
      img: 'by.svg',
      docHref: 'rental-agreement-by.html'
    },
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

}
